import { useEffect } from 'react';

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || '';

export default function HomeSEO() {
  useEffect(() => {
    const siteUrl = SITE_URL.replace(/\/$/, '');

    const schemaData = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '鳥取ではじめての家づくりガイド',
        url: siteUrl || '/',
        description:
          '鳥取で住宅購入を初めて検討する方向けのブログ。間取り・資金計画・土地選びをわかりやすく解説。',
        inLanguage: 'ja',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '鳥取ではじめての家づくりガイド',
        url: siteUrl || '/',
        logo: {
          '@type': 'ImageObject',
          url: 'https://public.readdy.ai/ai/img_res/2c450daa-ab1c-4449-ac53-d1ae0dbc5040.png',
        },
        address: {
          '@type': 'PostalAddress',
          addressRegion: '鳥取県',
          addressCountry: 'JP',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: siteUrl || '/',
          },
        ],
      },
    ];

    const existing = document.getElementById('home-schema');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = 'home-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.getElementById('home-schema')?.remove();
    };
  }, []);

  return null;
}
